import React from "react";

export default function PropertiesItem(props) {

    const { traitType, value } = props

    return (
        <div>
            <div className="property">
                <div className="property-header">
                    {traitType}
                </div>
                <div className="property-detail">
                    {value}
                </div>
                {/* <div className="property-rarity">
                    100% have this trait
                </div> */}
            </div>
        </div>
    )
}